import type { ComponentType } from "react";
import type { GameAdapter, GameTableProps } from "./game-core";
import { othelloAdapter } from "./othello/adapter";
import { OthelloTable } from "./othello/Table";
import { OthelloRules } from "./othello/Rules";
import { ginRummyAdapter } from "./gin-rummy/adapter";
import { GinRummyTable } from "./gin-rummy/Table";
import { GinRummyRules } from "./gin-rummy/Rules";
import { AcquireTable } from "./acquire/Table";
import { AcquireRules } from "./acquire/Rules";
import { LunaGenesisTable } from "./luna-genesis/Table";
import { LunaGenesisRules } from "./luna-genesis/Rules";

export interface GameEntry {
  gameId: string;
  displayName: string;
  tagline: string;
  /** Whether a match can be created and played today. Gin Rummy's engine is not built yet. */
  playable: boolean;
  /** Pure rules engine, or null until the game is implemented. */
  adapter: GameAdapter<unknown, unknown> | null;
  Table: ComponentType<GameTableProps> | null;
  Rules: ComponentType<{ onBack: () => void }>;
  /** Selectable seat counts for games that support more than two players; omitted means fixed two-player. */
  playerCounts?: number[];
}

export const GAMES: GameEntry[] = [
  {
    gameId: "othello",
    displayName: othelloAdapter.displayName,
    tagline: othelloAdapter.tagline,
    playable: true,
    adapter: othelloAdapter as unknown as GameAdapter<unknown, unknown>,
    Table: OthelloTable,
    Rules: OthelloRules,
  },
  {
    gameId: "gin-rummy",
    displayName: ginRummyAdapter.displayName,
    tagline: ginRummyAdapter.tagline,
    playable: true,
    adapter: ginRummyAdapter as unknown as GameAdapter<unknown, unknown>,
    Table: GinRummyTable,
    Rules: GinRummyRules,
  },
  {
    gameId: "acquire",
    displayName: "Acquire",
    tagline: "Build corporations. Buy the right stock.",
    playable: true,
    adapter: null,
    Table: AcquireTable,
    Rules: AcquireRules,
    playerCounts: [2, 3, 4, 5, 6],
  },
  {
    gameId: "luna-genesis",
    displayName: "Luna Genesis",
    tagline: "Build a colony. Claim the Moon.",
    playable: true,
    adapter: null,
    Table: LunaGenesisTable,
    Rules: LunaGenesisRules,
    playerCounts: [2, 3, 4, 5],
  },
];

export const gameById = (gameId: string): GameEntry | undefined => GAMES.find((g) => g.gameId === gameId);

/** Games that can be started right now, in menu order. */
export const playableGames = (): GameEntry[] => GAMES.filter((g) => g.playable);
